import { render, staticRenderFns } from "./TrinketItem.vue?vue&type=template&id=d69c4a28"
import script from "./TrinketItem.vue?vue&type=script&lang=js"
export * from "./TrinketItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports